import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Thumbnail } from '@shopify/polaris'
import DelIcon from 'react-icons/lib/md/close'

import Text from 'components/common/Text'
import { SHOPIFY_BLUE } from 'components/styles'

const Container = styled.div`
  width: 100%;
  display: flex;
  height: 6em;
  align-items: center;
  justify-content: space-between;
`
const LeftPart = styled.div`
  display: flex;
  align-items: center;
`
const TitleContainer = styled.div`
  margin-left: 1em;
`
const IconContainer = styled.div`
  cursor: pointer;
`

class ProductCard extends Component {

  onDelIconClick = () => {
    const { onDelete, productId } = this.props
    onDelete(productId)
  }

  render () {
    const { title, image } = this.props
    return (
      <Container>
        <LeftPart>
          <Thumbnail source={image} size='small' />
          <TitleContainer>
            <Text>{title}</Text>
          </TitleContainer>
        </LeftPart>
        <IconContainer>
          <DelIcon color={SHOPIFY_BLUE} onClick={this.onDelIconClick} />
        </IconContainer>
      </Container>
    )
  }
}

ProductCard.propTypes = {
  productId: PropTypes.number, //eslint-disable-line
  image: PropTypes.string,
  title: PropTypes.string,
  onDelete: PropTypes.func
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/addCollection/ProductCard.js